import React, { useState,useEffect,useRef } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import SelectDateOnly from "../components/popups/SelectDateOnly";
import DaumPostCode from "../../components/popups/DaumPostCode";

import { ChangeDateFormat,isObjEmpty,ToggleDarkBackground, ChangeMobileFormat,isNull,isNullNumber, ChangeMobileNumber, 
        LoginAfterCheckLogin,escapeHtml, unescapeHtml,exceptTimeFromDate } from "../../components/common/Common";
import centerIcon from "../../img/icon/icon-center-class-03.svg";
import cancelIcon from "../../img/icon/icon-cancel.svg";
import noneImage from "../../img/sample03.png";
import "../../css/style.css";

//클래스 추가/편딥
const ParentDetail = () => {
  let { mem_idx } = useParams();
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const fileRef= useRef(null);

  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  //원생정보
  const newChildrenData = {ch_idx:0,mem_idx:Number(mem_idx),bh_idx:branch_idx,ch_code:"",ch_name:"",ch_birthday:"",ch_gender:1,ch_history:"",ch_image:0,ch_file:"",ch_memo:"",ch_rdate:""};

  const [varParentMode,setParentMode] = useState('');
  const [varParentInfo,setParentInfo] = useState({});

  const [varChildrenMode,setChildrenMode] = useState(true);
  const [varParentChildrenList,setParentChildrenList] = useState([]);
  const [varChildrenInfo,setChildrenInfo] = useState({});
  const [varChildrenIndex,setChildrenIndex] = useState(-1);
  /* const [varChildrenCode,setChildrenCode] = useState(''); //원생코드 */
  const [varChildrenMaxCode,setChildrenMaxCode] = useState(0);

  //원생사진
  const [varProfilePhoto,setProfilePhoto] = useState(noneImage);

  const GetParentInformation = async() => {
    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_parents_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const parentInfo = datas.parents[0];
        setParentInfo(parentInfo);   //학부모정보
        //원생코드 - 기본 
        setParentChildrenList(datas.childrens); //원생정보
        if(datas.childrens.length > 0) {
          let childData = datas.childrens[0];
          setChildrenInfo(childData);
          setChildrenIndex(0);
          //원생 사진
          if(childData.ch_image === 1 && !isNull(childData.ch_file)) {
            setProfilePhoto(`${process.env.REACT_APP_HOST}/member/${childData.ch_file}`);
          }
        }
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    //작업모드 
    if(Number(mem_idx) > 0) {
      setParentMode('disable-only');
      setChildrenMode(false);
    } 

    //학부모
    const newData = {mem_idx:Number(mem_idx),bh_idx:branch_idx,mem_code:"",mem_name:"",mem_id:"",mem_pwd:"",mem_mobile:"",mem_emergency:"",
      mem_zipcode:"",mem_addr1:"",mem_addr2:"",mem_consult_date:null,mem_consult_memo:"",idchk:0};
    setParentInfo(newData);

    //서버로부터 정보 호출
    if(Number(mem_idx) > 0) GetParentInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //정보입력부----------------------------------------------------------------------
  //정보입력부 - 학부모
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "mem_mobile" || name === "mem_emergency") {
      setParentInfo({...varParentInfo,[name]:ChangeMobileNumber(value)});
    } else if(name === "mem_consult_memo") {
      setParentInfo({...varParentInfo,[name]:escapeHtml(value)});
    } else if(name === "mem_id") {
      if(varParentInfo.idchk===1) setParentInfo({...varParentInfo,idchk:0,[name]:value});
      else setParentInfo({...varParentInfo,[name]:value});
    } else {
      setParentInfo({...varParentInfo,[name]:value});
    }
  }
  //정보입력부 - 원생
  const onChangeInputHandler2 = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "ch_gender") {
      setChildrenInfo({...varChildrenInfo,[name]:Number(value)});
    } else if(name === "ch_history" || name === "ch_memo") {
      setChildrenInfo({...varChildrenInfo,[name]:escapeHtml(value)});
    } else {
      setChildrenInfo({...varChildrenInfo,[name]:value});
    }
  }

  //수정모드로 변경 ----------------------------------------------------------------
  const onEditParentesHandler = (e) => {
    const diableBoxes = document.querySelectorAll(".disable-only");
    const showBoxes = document.querySelectorAll(".show-only");
    const hideBox = document.querySelector('.hide-only');
    const buttonNumBox = document.querySelector('.btn-no');
    for(var i1=0; i1 < diableBoxes.length; i1++) {
      diableBoxes[i1].classList.remove('disable-only');
    }
    for(var i2=0; i2 < showBoxes.length; i2++) {
      showBoxes[i2].classList.add('hide-only');
    }
    hideBox.classList.remove('hide-only');
    buttonNumBox.setAttribute('style','width:48%');
    setChildrenMode(true);
  }

  //학부모-------------------------------------------------------------------------------------
  //학부모 등록
  const onUpdateParentesHandler = async(e) => {
    if(varParentInfo.mem_name === "") {
      alert('학부모명을 먼저 입력하세요.'); return false;
    } else if (varParentInfo.mem_id === "") {
      alert('학부모계정을 먼저 입력하세요.'); return false;
    } else if (varParentInfo.idchk === 0) {
      alert('학부모계정에 대해 중복검사를 먼저 실행하세요.'); return false;
    } else if (varParentInfo.mem_mobile === "") {
      alert('휴대폰번호를 먼저 입력하세요.'); return false;
    /* } else if (varParentInfo.mem_emergency === "") {
      alert('긴급연락처를 먼저 입력하세요.'); return false;
    } else if (varParentInfo.mem_zipcode === "") {
      alert('주소를 먼저 선택하세요.'); return false; */
    }
    if(!window.confirm(`학부모정보(${varParentInfo.mem_name})를 저장하시겠습니까?`)) return false;

    const old_mem_idx = varParentInfo.mem_idx;
    const sendData = {dataInfo:varParentInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_parent_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //학부모가 추가등록된 경우
        if(old_mem_idx === 0) {
          //학부모 정보에 회원번호 변경
          mem_idx = datas.mem_idx;  //전달받은 학부모 고유번호 변경
          setParentInfo({...varParentInfo,mem_idx:mem_idx});  //학부모 정보 변경
        }

        //원생최대코드
        const MaxCode = datas.maxCode;    //443302
        let addCode = 0;
        let code = varParentInfo.mem_mobile.substr(-4);
        if(!isNull(MaxCode)) {
          addCode = Number(MaxCode.substr(-2));
        }

        //원생정보 변경
        if(varParentChildrenList.length > 0) {
          //원생 배열정보 변경
          let childList = [...varParentChildrenList]; 
          for(var i=0; i < childList.length; i++) {
            addCode++;
            childList[i].mem_idx = mem_idx;
            childList[i].ch_code = code + ('0' + addCode).slice(-2);
          }
          setChildrenMaxCode(addCode);
          setParentChildrenList(childList);
          //원생 현행정보 변경
          setChildrenInfo({...varChildrenInfo,mem_idx:mem_idx});
        }
        alert(datas.message);
      } else {
        alert(datas.message);
      }
    });
  }

  //학부모 삭제
  const onDeleteParentesHandler = async(e) => {
    if(!window.confirm(`학부모(${varParentInfo.mem_name})를 삭제하시겠습니까?`)) return false;

    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_parent`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Branch/ParentSet');
      } else {
        alert(datas.message);
      }
    });
  }

  //원생-------------------------------------------------------------------------------------
  //원생선택
  const  onSelectChildrenHandler = (e,inum) => {
    //console.log(varChildrenIndex,inum);
    let cloc = varChildrenIndex + inum;
    const cmax = varParentChildrenList.length;
    if(cloc < 0) cloc = 0;
    else if ( cloc >= cmax) cloc = cmax -1;
    console.log(cloc,varParentChildrenList);
    setChildrenIndex(cloc);
    const childData = varParentChildrenList[cloc];
    setChildrenInfo(childData);
    //원생사진
    if(childData.ch_image === 1 && !isNull(childData.ch_file)) {
      setProfilePhoto(`${process.env.REACT_APP_HOST}/member/${childData.ch_file}`);
    } else {
      setProfilePhoto(noneImage);
    }
  }

  //원생추가
  const onAddChildrenHandler = (e) => {
    const imax = varParentChildrenList?.length;
    if(isNull(varParentInfo.mem_mobile)|| varParentInfo.mem_idx === 0) {
      alert('학부모정보를 먼저 입력하고 저장하신후에 원생정보를 추가하세요.'); return false;
    }
    setParentMode('');

    //원생정보 객체 생성
    let code = varParentInfo.mem_mobile.substr(-4);
    const addCode = varChildrenMaxCode + 1;
    setChildrenMaxCode(addCode);

    let newData = {...newChildrenData};
    newData.ch_code = code + ('0' + addCode).slice(-2);  //원생코드 -> 출석시 사용
    newData.mem_idx = varParentInfo.mem_idx;  //부모회원번호
    setChildrenInfo(newData); //원생 초기화정보 추가
    setParentChildrenList(varParentChildrenList.concat(newData)); //원생배열에 추가
    setChildrenIndex(imax); //추가된 원생을 선택배열로
    //원생사진
    setProfilePhoto(noneImage);
  }

  //원생정보저장 -- 이미지 저장
  const onUpdateChildrenHandler = async(e) => {
    if(varParentInfo.mem_idx === 0) {
      alert('학부모정보를 먼저 저장한 후 원생정보를 추가하세요.');
    }
    if(varChildrenInfo.ch_code === "" && Number(varChildrenInfo.ch_idx) === 0) {
      alert('원생코드를 먼저 입력하세요'); return false;
    } else if (varChildrenInfo.ch_name === "") {
      alert('원생명을 먼저 입력하세요.'); return false;
    } else if (varChildrenInfo.ch_birthday === "") {
      alert('원생의 생일을 먼저 선택하세요.'); return false;
    } else if (isNullNumber(varChildrenInfo.ch_gender)) {
      alert('원생의 성별을 먼저 선택하세요.'); return false;
    }

    if(!window.confirm(`원생정보(${varChildrenInfo.ch_name})를 저장하시겠습니까?`)) return false;

    const profileImage = fileRef.current;
    console.log(profileImage.files[0]);
    if(!isNull(profileImage.files[0])) {
      let formData = new FormData();
      formData.append('member',profileImage.files[0]);
      await axios.post(`${process.env.REACT_APP_HOST}/member`, formData).then((res) => {
        console.log(res.data);
        if(res.data.retvalue === 1) {
          UpdateChildrenInformation(res.data.fileName);
        }
      });
    } else {
      UpdateChildrenInformation('');
    }
  }
  //원생정보저장
  const UpdateChildrenInformation = async(fileName) => {
    let old_ch_idx = varChildrenInfo.ch_idx;  //현재 선택된 원생의 고유번호
    const sendData = {dataInfo:varChildrenInfo,fileName:fileName};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_children_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const ch_idx = datas.ch_idx;
        let newData = {...varChildrenInfo};
        newData.ch_idx = ch_idx;
        let newList = varParentChildrenList.filter(el=>el.ch_idx !== old_ch_idx);  //배열에서 저장전 원생정보 삭제
        setParentChildrenList(newList.concat(newData)); //세로 저장된 원생정보 추가
        setChildrenInfo(newData); //현재 표시되는 원생정보로 변경
        setChildrenIndex(newList.length);  //원생정보의 배열번호 
        alert(datas.message);
      } else {
        alert(datas.message);
      }
    });
  }

  //원생삭제
  const onDeleteChildrenHandler = async(e) => {
    if(!window.confirm(`원생정보(${varChildrenInfo.ch_name})를 삭제하시겠습니까?`)) return false;
    if(varChildrenInfo.ch_idx === 0) {  //저장안된 원생
      DeleteChilfrenAfter(0);
    } else {  //저장되어 있는 원생
      const sendData = {ch_idx:varChildrenInfo.ch_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_children`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          DeleteChilfrenAfter(varChildrenInfo.ch_idx);
        } else {
          alert(datas.message);
        }
      });
    }
  }
  //원생 삭제후 처리
  const DeleteChilfrenAfter = (ch_idx) => {
    let newList = varParentChildrenList.filter(el=>el.ch_idx!==ch_idx);
    setParentChildrenList(newList);
    if(newList.length > 0) {
      let newData = newList[0];
      setChildrenInfo(newData);
      setChildrenIndex(0);

      //원생 사진
      if(newData.ch_image === 1 && !isNull(newData.ch_file)) {
        setProfilePhoto(`${process.env.REACT_APP_HOST}/member/${newData.ch_file}`);
      } else {
        setProfilePhoto(noneImage);
      }
    } else {
      setChildrenInfo(newChildrenData);
      setChildrenIndex(-1);
    }
  }

  //원생사진--------------------------------------------------------
  const onSelectPhotoHandler = (e) => {
    e.preventDefault();
    fileRef.current.click();
  }  
  const onSelectedPhotoHandler = (e) => {
    e.preventDefault();
    const uploadFile = e.currentTarget.files[0];
    //화면에 이미지 표시
    setProfilePhoto(URL.createObjectURL(uploadFile));
    setChildrenInfo({...varChildrenInfo,ch_image:1});
  }
  const onDeletePhotoHandler = async(e) => {
    if(!window.confirm(`원생사진(${varChildrenInfo.ch_name})을 삭제하시겠습니까?`)) return false;
    //서버에 등록된 사진이면 
    if(varChildrenInfo.ch_image === 1 && !isNull(varChildrenInfo.ch_file)) {
      const sendData = {ch_idx:varChildrenInfo.ch_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_children_photo`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          setProfilePhoto(noneImage);
          setChildrenInfo({...varChildrenInfo,ch_image:0,ch_file:''});
        } else {
          alert(datas.message);
        }
      });
    } else {
      setProfilePhoto(noneImage);
      setChildrenInfo({...varChildrenInfo,ch_image:0});
    }
  }

  //날짜선택 팝업창--------------------------------------------------------------------------------------
  const [varPopupDaySelect,setPopupDaySelect] = useState(false);  //팝업창 열기/닫기
  const [varDate,setDate] = useState(null); //선택된 날짜
  const [varStudyIndex,setStudyIndex] = useState(0); 
  const onChangeDateHandler = (e,imode) => {
    setStudyIndex(imode);
    let csdate = "";

    if(imode === 0) csdate = varParentInfo.mem_consult_date;
    else if(imode === 1) csdate = varChildrenInfo.ch_birthday;
    else csdate = varChildrenInfo.ch_birthday;

    const sdate = new Date(csdate);
    setDate(sdate);

    //팝업창 위치조정
    /* const hasbtns = document.querySelectorAll('.cal-btn');
    const toppos = hasbtns[imode];
    const offsetY = window.pageYOffset + toppos.getBoundingClientRect().top - 500;
    const popupWin = document.querySelector('.layer-pop-select-date');
    popupWin.setAttribute('style',`top:${offsetY}px`); */
    //팝업창 호출
    TogglePopupDaySelect(true);
  }
  //팝업창 - 날짜 설정값 저장
  const ChangedDate = (date,imode) => {
    if(date === "" ) date = null;
    console.log(date,imode);
    const ndate = ChangeDateFormat(date);
    if(imode === 0) setParentInfo({...varParentInfo,mem_consult_date:ndate});
    else if(imode === 1) setChildrenInfo({...varChildrenInfo,ch_birthday:ndate});
    else setChildrenInfo({...varChildrenInfo,ch_rdate:ndate});
    //팝업창 닫기
    TogglePopupDaySelect(false);
  }
  //팝업창 열기/닫기
  const TogglePopupDaySelect = (bmode) => {
    setPopupDaySelect(bmode);
    ToggleDarkBackground(bmode);
  }

  //우편번호/주소 검색 팝업창 열기/닫기-------------------------------------------------------------------------------------
  const [varOpenZipcode,setOpenZipcode] = useState(false);
  const ClosePopupZipcode = (bmode) => {
    setOpenZipcode(bmode);
  };
  //우편번호 선택으로 우편번호/주소와 같이 반환
  const ChangeAddress = (zipcode,fullAddr,roadAddr,locString) => {
    console.log(zipcode,fullAddr,roadAddr,locString);
    //아래 함수가 실행되기전에 주소가 선택되면 초기화됨
    setParentInfo((prevState)=>{return{...prevState,mem_zipcode:zipcode,mem_addr1:roadAddr}});
  };

  //계정중복확인
  const onCheckIDHandler = (e) => {
    const sendData = {mem_id:varParentInfo.mem_id};
    console.log(sendData);
    axios.post(`${process.env.REACT_APP_HOST}/branch_check_parent_id`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        setParentInfo({...varParentInfo,idchk:1});
      } else {
        setParentInfo({...varParentInfo,mem_id:''});
      }
    });
  }

  return isObjEmpty(varParentInfo)?null:(
    <div className="vh-content parent-view-wrap">
      <HeaderBranchTitle varPageTitle={Number(mem_idx)===0?'학부모 등록':'학부모 상세'} varBackString={'../Branch/ParentSet'}/>
      <div className="vh-content-body">
        {/* 학부모정보 */}
        <div className="parent-info-wrap">
          <div className="center-wrap">
            <div className="info-box">
              <p className="info-tit">학부모 정보</p>
              <div className="info-con">
                {Number(mem_idx)===0?null:
                  <div className="input-line">
                    <p>학부모 코드 <font style={{color:"red",fontSize:"18px"}}>*</font></p>
                    <div>
                      <input type="text" name="mem_code" value={varParentInfo.mem_code||""} className={`${varParentMode}`} onChange={e=>onChangeInputHandler(e)}/>
                    </div>
                  </div>
                }
                <div className="input-line">
									<p>학부모명 <font style={{color:"red",fontSize:"18px"}}>*</font></p>
									<div>
                    <input type="text" name="mem_name" placeholder="학부모명을 입력하세요." value={varParentInfo.mem_name||""} className={`${varParentMode}`} onChange={e=>onChangeInputHandler(e)}/>
									</div>
								</div>
                <div className="input-line">
									<p>학부모 계정 <font style={{color:"red",fontSize:"18px"}}>*</font></p>
									<div>
                    <div style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
                      <input type="text" name="mem_id" placeholder="학부모 계정을 입력하세요." value={varParentInfo.mem_id||""} className={`${varParentMode}`} onChange={e=>onChangeInputHandler(e)}/>
                      <button className={`btn ${varParentMode}`} style={{width:"130px",marginLeft:"5px"}} onClick={e=>onCheckIDHandler(e)}>중복확인</button>
                    </div>
                    <p style={{fontSize:"11px",fontStyle:"italic",color:"#bbb"}}>☀︎ 로그인 비밀번호는 휴대폰번호의 뒷자리 4자리 숫자입니다.</p>
                  </div>
								</div>
                <div className="input-line">
									<p>휴대폰 번호 <font style={{color:"red",fontSize:"18px"}}>*</font></p>
									<div>
                    <input type="text" name="mem_mobile" placeholder="휴대폰 번호를 입력하세요." value={ChangeMobileFormat(varParentInfo.mem_mobile)||""} className={`${varParentMode}`} onChange={e=>onChangeInputHandler(e)}/>
									</div>
								</div>
                <div className="input-line">
									<p>긴급 연락처</p>
									<div>
                    <input type="text" name="mem_emergency" placeholder="긴급 연락처를 입력하세요." value={ChangeMobileFormat(varParentInfo.mem_emergency)||""} className={`${varParentMode}`} onChange={e=>onChangeInputHandler(e)}/>
									</div>
								</div>
                <div className="input-line">
                  <p>주소</p>
                  <div>
                    <div className="has_btn" onClick={e=>ClosePopupZipcode(true)} style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                      <input type="text" className={`${varParentMode}`} name="mem_zipcode" value={varParentInfo.mem_zipcode||""} style={{width:"100px"}} readOnly/>
                      <button className={`btn ${varParentMode}`} style={{width:"100px"}} onClick={e=>ClosePopupZipcode(true)}>우편번호</button>
                    </div>
                    <input type="text" name="mem_addr1" className={`fix_input ${varParentMode}`} style={{marginTop:"3px"}} value={varParentInfo.mem_addr1||""} readOnly/>
                    <input type="text" name="mem_addr2" className={`mt03 ${varParentMode}`} style={{marginTop:"3px"}} value={varParentInfo.mem_addr2||""} placeholder="상세주소" onChange={e=>onChangeInputHandler(e)}/>
                  </div>
                </div>
                <div className="input-line">
									<p>상담일</p>
									<div>
										<div className="has-btn" style={{width:"100%"}}>
											<input type="text" name="mem_consult_date" className={`input-cal ${varParentMode}`} value={varParentInfo.mem_consult_date||""} placeholder="상담일자를 선택하세요." readOnly/>
											<button className="cal-btn" onClick={e=>onChangeDateHandler(e,0)}><img src={centerIcon} alt=""/></button>
										</div>
									</div>
								</div>
                <div className="input-line">
									<p>상담 메모</p>
									<div>
										<textarea name="mem_consult_memo" className={`${varParentMode}`} style={{width:"100%"}} value={unescapeHtml(varParentInfo.mem_consult_memo)||""} onChange={e=>onChangeInputHandler(e)}/>
									</div>
								</div>
              </div>
            </div>
            <div className="info-box">
              {!varChildrenMode?null:
                <div className="flex">
                  <p className="info-tit">원생 정보</p>
                  {varChildrenInfo.ch_idx===0?
                    <div>
                      <button className="update" onClick={e=>onUpdateChildrenHandler(e)}>등록</button>
                      <button className="delete" onClick={e=>onDeleteChildrenHandler(e)}>제거</button>
                    </div>
                  :
                    <div>
                      <button className="add" onClick={e=>onAddChildrenHandler(e)}>추가</button>
                      {varChildrenIndex===-1?null:<button className="update" onClick={e=>onUpdateChildrenHandler(e)}>저장</button>}
                      {varChildrenIndex===-1?null:<button className="delete" onClick={e=>onDeleteChildrenHandler(e)}>제거</button>}
                    </div>
                  }
                </div>
              }
              {varParentChildrenList.length === 0 ? null:
                <div className="info-con">
                  <div className="input-line">
                    <p>자녀수</p>
                    <div style={{display:"flex",justifyContent:"space-between"}}>
                      <p>{varChildrenIndex+1} / {varParentChildrenList.length}</p>
                      {varParentChildrenList.length<=1? null:
                        <div style={{width:"auto"}}>
                          <button id="prev-child" style={{width:"40px",marginRight:"5px"}} onClick={e=>onSelectChildrenHandler(e,-1)}>&lt;</button>
                          <button id="next-child" style={{width:"40px"}} onClick={e=>onSelectChildrenHandler(e,1)}>&gt;</button>
                        </div>
                      }
                    </div>
                  </div>
                  <div className="input-line">
                    <p>원생코드</p>
                    <div>
                      <input type="text" name="ch_code" className='disable-all' value={varChildrenInfo.ch_code||""} readOnly/>
                    </div>
                  </div>
                  <div className="input-line">
                    <p>원생명</p>
                    <div>
                      <input type="text" name="ch_name" className={`${varParentMode}`} placeholder="원생명을 입력하세요." value={varChildrenInfo.ch_name||""} onChange={e=>onChangeInputHandler2(e)}/>
                    </div>
                  </div>
                  <div className="input-line">
                    <p>생년월일</p>
                    <div>
                      <div className="has-btn" style={{width:"100%"}}>
                        <input type="text" name="ch_birthday" className={`${varParentMode}`} value={varChildrenInfo.ch_birthday||""} placeholder="생일을 선택하세요." readOnly/>
                        <button className={`cal-btn ${varParentMode}`} onClick={e=>onChangeDateHandler(e,1)}><img src={centerIcon} alt=""/></button>
                      </div>
                    </div>
                  </div>
                  <div className="input-line">
                    <p>성별</p>
                    <div className="field-group flex">
                      <div className="radio-group" style={{width:"40%"}}>
                        <input type="radio" value={1} name="ch_gender" id="ch_gender1" className={`input-radio ${varParentMode}`} style={{width:"30px"}} checked={varChildrenInfo.ch_gender===1} onChange={e=>onChangeInputHandler2(e)}/>
                        <label htmlFor="ch_gender1" className={`radio-label ${varParentMode}`}>남아</label>
                      </div>
                      <div className="radio-group" style={{width:"40%"}}>
                        <input type="radio" value={2} name="ch_gender" id="ch_gender2" className={`input-radio ${varParentMode}`} style={{width:"30px"}} checked={varChildrenInfo.ch_gender===2} onChange={e=>onChangeInputHandler2(e)}/>
                        <label htmlFor="ch_gender2" className={`radio-label ${varParentMode}`}>여아</label>
                      </div>
                    </div>
                  </div>
                  <div className="input-line">
                    <p>발달 기록</p>
                    <div>
                      <textarea name="ch_history" className={`${varParentMode}`} style={{width:"100%"}} placeholder="발달 기록을 입력하세요." value={unescapeHtml(varChildrenInfo.ch_history)||""} onChange={e=>onChangeInputHandler2(e)}/>
                    </div>
                  </div>
                  <div className="input-line">
                    <p>사진등록</p>
                    <div className="file-line">
                      <div name="ch_image" id="file" className={`btn-upload ${varParentMode}`} onClick={e=>onSelectPhotoHandler(e)}>파일 선택</div>
                      <input type="file" name="select_file" style={{display:"none"}} ref={fileRef} onChange={e=>onSelectedPhotoHandler(e)}/>
                      <div className="file-img">
                        <img id="ch_file" src={varProfilePhoto} alt="" style={{zIndex:"0"}}/>
                        {varChildrenInfo.ch_image === 0?null:
                          <img src={cancelIcon} alt="" className={`${varParentMode}`} style={{backgroundColor:"transparent"}} onClick={e=>onDeletePhotoHandler(e)}/>
                        }
                      </div>
                    </div>									
                  </div>
                  <div className="input-line">
                    <p>원생 메모</p>
                    <div>
                      <textarea name="ch_memo" className={`${varParentMode}`} style={{width:"100%"}} placeholder="원생 메모를 입력하세요." value={unescapeHtml(varChildrenInfo.ch_memo)||""} onChange={e=>onChangeInputHandler2(e)}/>
                    </div>
                  </div>
                  <div className="input-line">
                    <p>등록일자</p>
                    <div className="has-btn" style={{width:"100%"}}>
                      <input type="text" name="ch_rdate" className={`${varParentMode}`} value={exceptTimeFromDate(varChildrenInfo.ch_rdate)} placeholder="등록일자를 선택하세요." readOnly/>
                      <button className={`cal-btn ${varParentMode}`} onClick={e=>onChangeDateHandler(e,2)}><img src={centerIcon} alt=""/></button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div className="form-contoller bt-btn">
            <Link to={'/Branch/ParentSet'} className="form-contoller-btn btn-no" style={Number(mem_idx)===0?{width:"48%"}:{}}>취소</Link>
            <button className={Number(mem_idx)===0?"form-contoller-btn btn-yes hide-only":"form-contoller-btn btn-yes show-only"} style={{width:"35%"}} onClick={e=>onEditParentesHandler(e)}>수정</button>
            <button className={Number(mem_idx)===0?"form-contoller-btn btn-del hide-only":"form-contoller-btn btn-yes show-only"} style={{width:"35%"}} onClick={e=>onDeleteParentesHandler(e)}>삭제</button>
            <button className={Number(mem_idx)===0?"form-contoller-btn btn-yes":"form-contoller-btn btn-yes hide-only"} onClick={e=>onUpdateParentesHandler(e)} style={{marginRight:"0"}}>확인</button>
          </div>
        </div>
      </div>
      <SelectDateOnly varStudyIndex={varStudyIndex} varDate={varDate} setDate={setDate} varPopupDaySelect={varPopupDaySelect} 
                        TogglePopupDaySelect={TogglePopupDaySelect} ChangedDate={ChangedDate}/>
      {/* 우편번호/주소 검색*/}
      <DaumPostCode varOpenZipcode={varOpenZipcode} ChangeAddress={ChangeAddress} ClosePopupZipcode={ClosePopupZipcode}/>
    </div>	
  );
}
export default ParentDetail;